import { render, staticRenderFns } from "./BaseListSelect.vue?vue&type=template&id=2bb4bfd2"
import script from "./BaseListSelect.vue?vue&type=script&lang=js"
export * from "./BaseListSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports